module.exports = __webpack_public_path__ + "img/border_corners.41a3f73a.png";